import moment from 'moment';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IoMdRefresh } from 'react-icons/io';
import { FaHourglassEnd, FaTasks } from 'react-icons/fa';
import { LuCalendarClock } from 'react-icons/lu';
import {
  getDashboardMissedDeadline,
  getDashboardApproachingDeadline,
} from '../../../redux/MainAction';

const DeadlinesCard = () => {
  const dispatch = useDispatch();
  const [firstRefresh, setFirstRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const missed = useSelector(
    (state) => state.Webtracker.dashboardmissedDeadline?.rows
  );
  const approach = useSelector(
    (state) => state.Webtracker.dashboardApproachingDeadline?.rows
  );

  async function fetchDashboardData(isFirstRefresh) {
    setIsLoading(true);
    if (isFirstRefresh) setFirstRefresh(true);

    await dispatch(getDashboardApproachingDeadline({ offset: 0, limit: 5 }));
    await dispatch(getDashboardMissedDeadline({ offset: 0, limit: 5 }));

    setIsLoading(false);
  }

  return (
    <div className="card dead_dash m-b-20 enhanced-card">
      <div className="border_class d-flex align-items-center justify-content-between">
        <h5 className="dash-card-title font-20 ml-3">Deadlines</h5>

        {firstRefresh ? (
          <IoMdRefresh
            onClick={fetchDashboardData}
            title="Refresh Data"
            className="dashboard_reload_icon"
          />
        ) : null}
      </div>

      <div className="card-body dash_cards">
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center h-100">
            <div className="spinner-border text-primary " role="status"></div>
          </div>
        ) : firstRefresh ? (
          <>
            <div className="d-flex justify-content-between">
              <h4
                className="header-title"
                style={{ color: '#23486A', fontSize: '18px' }}
              >
                <FaHourglassEnd className="font-18 mr-2" /> Deadlines
              </h4>
              <ul className=" nav nav-tabs nav-tabs-custom mb-4" role="tablist">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#missed_1"
                    role="tab"
                    style={{ backgroundColor: '#f9fbfe', fontSize: '17px' }}
                  >
                    <span className="d-none d-md-block">Missed</span>
                    <span className="d-block d-md-none">
                      <i className="mdi mdi-home-variant h5"></i>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#approaching_1"
                    role="tab"
                    style={{ backgroundColor: '#f9fbfe', fontSize: '17px' }}
                  >
                    <span className="d-none d-md-block">Approaching</span>
                    <span className="d-block d-md-none">
                      <i className="mdi mdi-account h5"></i>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="tab-content mb-2">
              <div className="tab-pane active" id="missed_1" role="tabpanel">
                <div className="table-responsive dash-tdAct dead-dash-tdAct pb-2">
                  <table className="table table-vertical mb-0 border-collapse">
                    {missed?.length !== 0 ? (
                      <thead>
                        <tr>
                          <th className="font-14 py-1">Name</th>
                          <th className="font-14 text-right py-1">End Date</th>
                        </tr>
                      </thead>
                    ) : null}
                    <tbody className="table_scroll">
                      {missed?.length === 0 ? (
                        <td colSpan={2}>
                          <div className="d-flex flex-column justify-content-center align-items-center mt-4">
                            <span className="font-40 text-purple icon_border mb-4">
                              <LuCalendarClock />
                            </span>
                            <span className="font-14 text-center text-muted">
                              You have no missed deadlines. Good job!{' '}
                            </span>
                          </div>
                        </td>
                      ) : (
                        missed?.map((deadline, idx) => (
                          <tr key={idx}>
                            <td className="font-14 py-1">
                              <FaTasks className="text-primary mr-2" />
                              {deadline?.name}
                            </td>
                            <td className="font-14 text-right py-1">
                              {moment(deadline?.endDate).format('DD MMM, YY')}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="tab-pane" id="approaching_1" role="tabpanel">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <table className="table table-vertical mb-0 border-collapse">
                    {approach?.length !== 0 ? (
                      <thead>
                        <tr>
                          <th className="font-14 py-1">Name</th>
                          <th className="font-14 text-right py-1">End Date</th>
                        </tr>
                      </thead>
                    ) : null}
                    <tbody className="table_scroll ">
                      {approach?.length === 0 ? (
                        <td colSpan={2}>
                          <div className="d-flex flex-column justify-content-center align-items-center mt-4">
                            <span className="font-40 text-purple icon_border mb-4">
                              <LuCalendarClock />
                            </span>
                            <span className="font-14 text-center text-muted">
                              No upcoming deadlines.!{' '}
                            </span>
                          </div>
                        </td>
                      ) : (
                        approach?.map((deadline, idx) => (
                          <tr key={idx}>
                            <td className="font-14 py-1">
                              <FaTasks className="text-primary mr-2" />
                              {deadline?.name}
                            </td>
                            <td className="font-14 text-right py-1">
                              {moment(deadline?.endDate).format('DD MMM, YY')}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100">
            <button
              className="btn btn-primary font-14"
              onClick={() => fetchDashboardData(true)}
            >
              Load Data
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeadlinesCard;
